<template>
  <v-menu ref="dateMenuRef" v-bind="{...menuLocalProps, ...menuProps}" v-model="dateMenu">
    <template v-slot:activator="{ on }">
      <v-text-field v-bind="{...textFieldLocalProps, ...textFieldProps}"
                    :value="dateModelToShow"
                    @change="inputHandler"
                    @click:clear="onClearHandler"
                    v-on="on"/>
    </template>
    <v-date-picker v-bind="{...datePickerLocalProps, ...datePickerProps}" :value="value" @input="dateModelUpdate">
      <v-spacer/>
      <v-btn text color="primary" @click="dateMenu = false">
        Cancel
      </v-btn>
<!--      <v-btn text color="primary" @click="$refs.dateMenuRef.save(value)">-->
<!--        OK-->
<!--      </v-btn>-->
    </v-date-picker>
  </v-menu>
</template>

<script>
  import moment from 'moment'

  export default {
    name: "DateInput",
    props: ['value', 'menuProps', 'textFieldProps', 'datePickerProps'],
    data(){
      return{
        dateMenu: null,
        textFieldValue: null,
        menuLocalProps: {
          'close-on-content-click': false,
          transition: "scale-transition",
          'offset-y': true
        },
        textFieldLocalProps: {
          placeholder: moment().format("DD-MM-YYYY"),
          'append-icon': 'mdi-calendar-blank-outline',
          outlined: true,
          clearable: true,
          'hide-details': true
        },
        datePickerLocalProps: {
          'no-title': true,
          input: this.dateModelUpdate
        }
      }
    },
    computed: {
      dateModelToShow(){
        return this.value ? moment(this.value).format("DD-MM-YYYY") : "";
      }
    },
    methods: {
      inputHandler(value){
        if (value){
          const date = moment(value.toString(), "DD-MM-YYYY")
          if (date.isValid()){
            this.dateModelUpdate(moment(date).format('YYYY-MM-DD'))
          }
          else {
            this.dateModelUpdate(null)
          }
        }
      },
      onClearHandler(){
        this.dateModelUpdate(null)
        if (this.textFieldProps?.clear)
          this.textFieldProps.clear()
      },
      dateModelUpdate(value){
        this.$emit('input', value)
        if (this.datePickerProps?.input)
          this.datePickerProps.input(value)
        this.dateMenu = false
      }
    }
  }
</script>

<style scoped>

</style>
